<template>
  <div class="box" v-if="ShowPage">
    <div class="top">
      <img :src="$OSSBaseUrl+'log_wxt_yuan.png'" class="logo_image">
      <div class="text1">旺信通-接单响应雷达</div>
      <div class="text2">提升响应率80%以上 极速响应不丢单</div>
      <div style="margin-top: 7.4vw">
        <div v-for="(item,index) in list" :key="index" class="payItem">
          <div class="payLeft">
            <span class="list_num">{{item.num}}</span>
            <span class="list_text">{{item.text}}</span>
          </div>
          <div @click="payButton(item.mark)" class="payButton">立即订购</div>
        </div>
      </div>
    </div>
    <div @click="payButton('点击跳转1688服务市场订购')" class="bottom">
      点击跳转1688服务市场订购
    </div>
  </div>
</template>
<script>
import { URL5 } from "@/utils/Redirect";
import {mapState} from "vuex";
export default {
  name: "Renewal",
  data(){
    let list = [
      {num:135,text:'元/季度',mark:"季度订购按钮"},
      {num:240,text:'元/半年',mark:"半年订购按钮"},
      {num:420,text:'元/一年',mark:"一年订购按钮"},
    ]
    return{
      list,
      ShowPage: false,
    }
  },
  computed:{
    ...mapState({
      UserInfo: (state) => {
          return state.Public.UserInfo
      }
    })
  },
  mounted(){
    for(let i in this.UserInfo.renewal){
      if(this.UserInfo.renewal[i].app_key == '1236050'){
        this.$router.replace({ path:'Renewal_RD'});
      }
    }
    this.ShowPage = true;
  },
  methods:{
    payButton(mark){
      let data = {
          page_from:'main_page',
          page_name:'Renewal',
          btn_name: mark,
          page_time:'0.00',
          receiver_id: '',
          page_param:{},
      };
      this.$store.dispatch('Public/inH5Record', data).then(res=>{
        window.location.href = URL5
      })
    }
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>